<oo-loading-container [status]="state.status">
  <ng-template>
    <oo-list-header title="Teams">
    </oo-list-header>
    <oo-teams-list [isManageable]="false" [tournamentId]="state.compGroup.tournament.id"></oo-teams-list>
  </ng-template>
</oo-loading-container>

